import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { SET_INITIAL_TOKEN } from '../types';
import { setInitialTokenPending, setInitialTokenFulfilled, setInitialTokenRejected } from '../actions/setInitialTokenActions';
import { sendApiRequest } from '../actions/apiRequestActions';

const createPayload = (payload, filters) => ({
  method: 'get',
  url: `user/SetInitialToken?accessToken=${filters.accessToken}`,
  onSuccess: [setInitialTokenFulfilled],
  onError: [setInitialTokenRejected],
  data: payload,
});
const meta = {
  api: 'ajaxApi',
};

const setInitialTokenEpic$ = (action$, state$) => action$.pipe(
  ofType(SET_INITIAL_TOKEN.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    const filters = { accessToken: state$.value.oidc.user.access_token };
    return merge(
      of(setInitialTokenPending()),
      of(sendApiRequest(createPayload(payload, filters), meta)),
    );
  }),
);

export default setInitialTokenEpic$;


// WEBPACK FOOTER //
// ./src/epics/setInitialTokenEpic.js